module.exports = __webpack_public_path__ + "img/password-blue.5bfa858a.svg";